// Libs
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import React, { useEffect, useState } from "react";
import { useTranslate } from "react-admin";
import globalUseStyles from '../../../styles/globalCustomStyles';
import BottomButton from '../../Buttons/BottomButton';
import ChooseCentileButton from '../../Buttons/ChooseCentileButton';
import ChooseDateButton from "../../Buttons/ChooseDateButton";
import ChooseDaysOfWeekButton from '../../Buttons/ChooseDaysOfWeekButton';
import ChooseHoursButton from '../../Buttons/ChooseHoursButton';
import ChoosePublicHolidaysButton from '../../Buttons/ChoosePublicHolidaysButton';

const ParametersPotentialGainComponent = (props) => {
  const t = useTranslate();
  const globalClasses = globalUseStyles();

  const [disabled, setDisabled] = useState(true);
  const [daysOfWeek, setDaysOfWeek] = useState(props.initialParameters.daysOfWeek);
  const [hoursRange, setHoursRange] = useState(props.initialParameters.hoursRange);
  const [centile, setCentile] = useState(props.initialParameters.centile);
  const [period, setPeriod] = useState(props.initialParameters.period);
  const [publicHolidays, setPublicHolidays] = useState(props.initialParameters.publicHolidays);

  const onCalculate = () => {
    props.setParametersBack && props.setParametersBack(
      daysOfWeek,
      hoursRange,
      centile,
      period,
      publicHolidays
    )
    setDisabled(true);
  }

  useEffect(() => {
    if (daysOfWeek === props.initialParameters.daysOfWeek && hoursRange === props.initialParameters.hoursRange && centile === props.initialParameters.centile && period === props.initialParameters.period && publicHolidays === props.initialParameters.publicHolidays) setDisabled(true)
    else
      setDisabled(false)
  }, [daysOfWeek, hoursRange, centile, period, publicHolidays]);

  return (
    <Grid2 container direction="row" justifyContent="center" alignItems="center"
      spacing={5}
      style={{ padding: '0 !important' }}
    >
      <Grid2 item="true" small={8} medium={8} big={8} >
        <ChooseDateButton startDate={period[0]} endDate={period[1]} onDateChange={setPeriod} maxDaysRange={365} />
      </Grid2>
      <Grid2 item="true" small={4} medium={4} big={4} >
        <ChooseCentileButton centile={centile} setCentile={setCentile} />
      </Grid2>
      <Grid2 item="true" small={8} medium={8} big={8} >
        <ChooseDaysOfWeekButton daysOfWeek={daysOfWeek} setDaysOfWeek={setDaysOfWeek} />
        <ChoosePublicHolidaysButton publicHolidays={publicHolidays} setPublicHolidays={setPublicHolidays} />
      </Grid2>
      <Grid2 item="true" small={4} medium={4} big={4} >
        <ChooseHoursButton hoursRange={hoursRange} setHoursRange={setHoursRange} />
      </Grid2>
      <Grid2 item="true" small={12} medium={12} big={12} >
        <BottomButton
          onClick={onCalculate}
          disabled={disabled}
          label={t('resources.global.calculate')}
        />
      </Grid2>
    </Grid2>
  )
}

export default ParametersPotentialGainComponent;
